/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PlzInputs */

const en__field_plz = /** @type {(inputs: _Field_PlzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip Code`)
};

const de__field_plz = /** @type {(inputs: _Field_PlzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**
* | output |
* | --- |
* | "Zip Code" |
*
* @param {_Field_PlzInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_plz = /** @type {((inputs?: _Field_PlzInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PlzInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_plz(inputs)
	return de__field_plz(inputs)
});